import { useState } from "react";
import { Button, ButtonGroup, Grid } from "@mui/material";
import Templete from "../../template/Template";

export default function ContasPagar() {
    const [menuActive, setMenuActive] = useState("0");
    const [rows, setRows] = useState([]);

    return (
        <Templete menuActive="contas_pagar">
            <Grid container spacing={1}>
                <Grid item xs={false} sm={3}>
                    <h1>PAGAR</h1>
                </Grid>
            </Grid>
        </Templete>
    );
}